// console.log('app.js loaded');
// function replaceRegisteredSymbolsInText(node) {
//     if (node.nodeType === Node.TEXT_NODE) {
//         // Zamień znaki &reg; lub ® tylko w tekstowych węzłach
//         node.nodeValue = node.nodeValue.replace(/(®|&reg;)/g, '<sup class="milwaukee_reg">$1</sup>');
//     } else {
//         // Iteruj przez dzieci węzła
//         node.childNodes.forEach(child => replaceRegisteredSymbolsInText(child));
//     }
// }

// Rozpocznij od korzenia dokumentu (document.body)
// replaceRegisteredSymbolsInText(document.body);
 
$mainMenu = document.querySelector("#main_menu");

if ($mainMenu) {
  const navImageContainers = document.querySelectorAll(".nav__image");
  const navButtonContainers = document.querySelectorAll(".nav__button");
  const allElements = document.querySelectorAll("[data-sub-item]");
  const linksNoHref = document.querySelectorAll("[data-sub-item='00']");

  linksNoHref.forEach( function( link ) {
    link.addEventListener('click', function(event) {
      console.log(event.target)
    });
  } )
  // number indicates item level in menu hierarchy, modified wp nav structure is in /functions/main-menu-walker.php
  const elements0 = document.querySelectorAll('[data-sub-item="00"]');

  allElements.forEach(function (element) {
    element.addEventListener("click", function (event) {
      const imageUrl = event.target.getAttribute("data-image");
      const linkLabel = event.target.getAttribute("data-link-label");
      const linkUrl = event.target.getAttribute("data-link-url");

      if (!event.target.classList.contains("active")) {
        if (imageUrl) {
          navImageContainers.forEach(function (imageContainer) {
            imageContainer.style.backgroundImage = "url(" + imageUrl + ")";
            imageContainer.removeAttribute("hidden");
          });
        } else {
          navImageContainers.forEach(function (imageContainer) {
            imageContainer.style.backgroundImage = "url()";
            imageContainer.setAttribute("hidden", true);
          });
        }

        if (linkLabel) {
          navButtonContainers.forEach(function (buttonContainer) {
            buttonContainer.innerText = linkLabel;
          });
        } else {
          navButtonContainers.forEach(function (buttonContainer) {
            buttonContainer.innerText = "";
          });
        }

        if (linkUrl) {
          navButtonContainers.forEach(function (buttonContainer) {
            buttonContainer.setAttribute("href", linkUrl);
          });
        } else {
          navButtonContainers.forEach(function (buttonContainer) {
            buttonContainer.removeAttribute("href");
          });
        }
      } else {
        navImageContainers.forEach(function (imageContainer) {
          imageContainer.style.backgroundImage = "url()";
          imageContainer.setAttribute("hidden", true);
        });
        navButtonContainers.forEach(function (buttonContainer) {
          buttonContainer.innerText = "";
        });
        navButtonContainers.forEach(function (buttonContainer) {
          buttonContainer.removeAttribute("href");
        });
      }
    });
  });
  function removeActiveFromElements0() {
    // elements0.forEach(function (item) {
    //   //   item.classList.remove("active");
    // });
  }
  elements0.forEach(function (element) {
    element.addEventListener("click", function (event) {
      const targetElement = event.target;
      elements0.forEach(function (element) {
        if ( element != targetElement ){
          element.classList.remove("active");
        }
      });

      if (targetElement.classList.contains("active")) {
        targetElement.classList.remove("active");
        removeActiveFromElements0();
      } else {
        removeActiveFromElements0();
        targetElement.classList.add("active");
      }
    });
  });

  document.addEventListener("click", function (event) {
    let clickedOutsideElements0 = true;
    for (let element of elements0) {
      if (element.contains(event.target)) {
        clickedOutsideElements0 = false;
        break;
      }
    }

    if (clickedOutsideElements0) {
      removeActiveFromElements0();
    }
  });

  const dropIcons = document.querySelectorAll('.drop__icon');
  const productCatsLvl1 = document.querySelectorAll('[data-depth="1"]');
  const productCatsLvl2 = document.querySelectorAll('[data-depth="2"]');
  const productCatsLvl3 = document.querySelectorAll('[data-depth="3"]');
  const productCatsLvl4 = document.querySelectorAll('[data-depth="4"]');

  dropIcons.forEach( function( element ) {
    element.addEventListener("click", function (event) {
      const parentCatID = event.target.closest('li').getAttribute('data-parent-id');
      const catID = event.target.closest('li').getAttribute('data-id');

      event.target.classList.toggle('active');

      let parentLI = event.target.closest('li');
      let parentUL = event.target.closest('ul');
      if ( !event.target.classList.contains('active') ) {
        parentLI.classList.remove('active');
        let siblings = parentUL.querySelectorAll(':scope > li:not(.active)');
        siblings.forEach( sibling => {
          sibling.classList.remove('uk-hidden')
        } )
      } else {
        parentLI.classList.add('active');
        let siblings = parentUL.querySelectorAll(':scope > li:not(.active)');
        siblings.forEach( sibling => {
          sibling.classList.add('uk-hidden')
        } )
      }

      console.log( event.target );

    })
  } )

  productCatsLvl1.forEach(function (element) {
    element.addEventListener("mouseenter", function (event) {
      let hoveredItemID = event.target.getAttribute("data-id");
      const parent = event.target.parentNode;
      for (let sibling of parent.children) {
        if (sibling !== element) {
          sibling.style.color = "inherit";
          sibling.style.backgroundColor = "inherit";
        }
      }
      event.target.style.color = "#BF0114";
      event.target.style.backgroundColor = "#F2F2F2";



      let allSubItems = document.querySelectorAll('[data-depth="2"], [data-depth="3"], [data-depth="4"]');
      let childSubItems = document.querySelectorAll(
          '[data-parent-id="' + hoveredItemID + '"]'
      );

      // hide all
      allSubItems.forEach(function (subItem) {
        subItem.classList.add("not_showing");
      });
      // show true children
      childSubItems.forEach(function (subItem) {
        subItem.classList.remove("not_showing");
      });
    });
  });
  productCatsLvl2.forEach(function (element) {
    element.addEventListener("mouseenter", function (event) {
      let hoveredItemID = event.target.getAttribute("data-id");
      const parent = event.target.parentNode;
      for (let sibling of parent.children) {
        if (sibling !== element) {
          sibling.style.color = "inherit";
          sibling.style.backgroundColor = "inherit";
        }
      }
      event.target.style.color = "#BF0114";
      event.target.style.backgroundColor = "#F2F2F2";


      let allSubItems = document.querySelectorAll('[data-depth="3"], [data-depth="4"]');
      let childSubItems = document.querySelectorAll('[data-parent-id="' + hoveredItemID + '"]');

      // hide all
      allSubItems.forEach(function (subItem) {
        subItem.classList.add("not_showing");
      });
      // show true children
      childSubItems.forEach(function (subItem) {
        subItem.classList.remove("not_showing");
      });
    });
  });
  productCatsLvl3.forEach(function (element) {
    element.addEventListener("mouseenter", function (event) {
      let hoveredItemID = event.target.getAttribute("data-id");
      const parent = event.target.parentNode;
      for (let sibling of parent.children) {
        if (sibling !== element) {
          sibling.style.color = "inherit";
          sibling.style.backgroundColor = "inherit";
        }
      }
      event.target.style.color = "#BF0114";
      event.target.style.backgroundColor = "#F2F2F2";


      let allSubItems = document.querySelectorAll('[data-depth="4"]');
      let childSubItems = document.querySelectorAll('[data-parent-id="' + hoveredItemID + '"]');

      // hide all
      allSubItems.forEach(function (subItem) {
        subItem.classList.add("not_showing");
      });
      // show true children
      childSubItems.forEach(function (subItem) {
        subItem.classList.remove("not_showing");
      });
    });
  });
  productCatsLvl4.forEach(function (element) {
    element.addEventListener("mouseenter", function (event) {
      let hoveredItemID = event.target.getAttribute("data-id");
      const parent = event.target.parentNode;
      for (let sibling of parent.children) {
        if (sibling !== element) {
          sibling.style.color = "inherit";
          sibling.style.backgroundColor = "inherit";
        }
      }
      event.target.style.color = "#BF0114";
      event.target.style.backgroundColor = "#F2F2F2";


      let allSubItems = document.querySelectorAll('[data-depth="5"]');
      let childSubItems = document.querySelectorAll('[data-parent-id="' + hoveredItemID + '"]');

      // hide all
      allSubItems.forEach(function (subItem) {
        subItem.classList.add("not_showing");
      });
      // show true children
      childSubItems.forEach(function (subItem) {
        subItem.classList.remove("not_showing");
      });
    });
  });



}

function isMobileAndSmallScreen() {
  const userAgent = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  const isLargeScreen = window.innerWidth < 961;

  return isMobile || isLargeScreen;
}

document.addEventListener("DOMContentLoaded", () => {
  const menuItemsColumns = document.querySelectorAll(".primary_submenu");
  if ( !isMobileAndSmallScreen() ) {
    menuItemsColumns.forEach( (parentItem) => {

      let items = parentItem.querySelectorAll("li[data-depth]");

      // Create columns
      let column1 = document.createElement("div");
      column1.classList.add("column");
      let column2 = document.createElement("div");
      column2.classList.add("column");
      let column3 = document.createElement("div");
      column3.classList.add("column");
      let column4 = document.createElement("div");
      column4.classList.add("column");

      // Append columns to the container
      parentItem.innerHTML = ""; // Clear the container
      parentItem.appendChild(column1);
      parentItem.appendChild(column2);
      parentItem.appendChild(column3);
      parentItem.appendChild(column4);

      // Distribute items into columns
      items.forEach((item) => {
        let depth = item.getAttribute("data-depth");
        switch (depth) {
          case "1":
            column1.appendChild(item);
            break;
          case "2":
            column2.appendChild(item);
            break;
          case "3":
            column3.appendChild(item);
            break;
          case "4":
            column4.appendChild(item);
            break;
        }
      });
    } )
  }
});

//Form ask for availability
document.addEventListener("DOMContentLoaded", function () {
  var popup = document.getElementById("form-popup");
  var openPopupButton = document.getElementById("ask-availability-button");
  var closePopupButton = document.querySelector(".close-popup");

  if (openPopupButton) {
    openPopupButton.addEventListener("click", function (e) {
      e.preventDefault();
      popup.style.display = "flex";
    });
  }

  if (closePopupButton) {
    closePopupButton.addEventListener("click", function () {
      popup.style.display = "none";
    });
  }

  window.addEventListener("click", function (e) {
    if (e.target === popup) {
      popup.style.display = "none";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var formPopup = document.getElementById("form-popup");
  var responseOutput = document.querySelector(".wpcf7-response-output");

  // Sprawdź, czy popup istnieje i czy responseOutput nie jest pusty
  if (formPopup && responseOutput && responseOutput.textContent.trim() !== "") {
    // Wyświetl popup
    formPopup.style.display = "flex";
  }
  if (
      responseOutput &&
      responseOutput.innerText.trim() ===
      "Twoja wiadomość została wysłana. Dziękujemy!"
  ) {
    // Dodaj klasę 'sent' do .wpcf7
    if (formPopup) {
      formPopup.classList.add("sent");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    // Sprawdza, czy kliknięto poza elementem menu__lvl_2 i czy istnieje aktywny element
    if ( !event.target.closest(".menu__lvl_2") && event.target.getAttribute('data-sub-item') != 0 ) {
      // Znajdź wszystkie elementy z klasą 'active' i atrybutem data-sub-item="00"
      const activeElements = document.querySelectorAll(
          'header .dropdown a[data-sub-item="00"].active'
      );

      if (activeElements) {
        // Usuń klasę 'active' z tych elementów
        activeElements.forEach(function (element) {
          element.classList.remove('active');
        });
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const toggleLink = document.querySelector("a.search_icon");
  const searchInput = document.querySelector("input.phrase");

  if (toggleLink && searchInput) {
    toggleLink.addEventListener("click", function () {
      setTimeout(function () {
        searchInput.focus();
      }, 400);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var variation = document.querySelector(".variations");
  var labels = document.querySelectorAll(".variations .label label");

  labels.forEach(function (label) {
    if (label.textContent === "Model") {
      label.textContent = "Wybierz wariant:";
    }
  });

  if (variation !== null) {
    variation.style.display = "block";
  }
});

function updateMainMargin() {
  var header = document.querySelector("header");
  var main = document.querySelector("main");
  var searchMenu = document.querySelector('.search_result.menu ');

  if (header && main) {
    var headerHeight = header.offsetHeight;

    var totalHeight = headerHeight;
    main.style.marginTop = totalHeight + 'px';
  }
  if (header && searchMenu) {
    var headerHeight = header.offsetHeight;

    var totalHeight = headerHeight;
    searchMenu.style.marginTop = totalHeight + 'px';
  }

}
document.addEventListener("DOMContentLoaded", function() {
  updateMainMargin();
  window.addEventListener("resize", updateMainMargin);
});

function updateNoticeMargin() {
  var header = document.querySelector("header");
  var noticesWrapper = document.querySelector(".woocommerce-notices-wrapper");
  if (noticesWrapper && noticesWrapper.innerHTML.trim() !== '') {
    if (header && noticesWrapper) {
      var headerHeight = header.offsetHeight;
      var totalHeight = 16 + headerHeight;
      noticesWrapper.style.marginTop = totalHeight + 'px';
    }
  }
}

function handleNotices() {
  var noticesWrapper = document.querySelector(".woocommerce-notices-wrapper");

  if (noticesWrapper && noticesWrapper.innerHTML.trim() !== '') {
    // Show the notice
    noticesWrapper.style.opacity = '1';

    // Hide the notice after 5 seconds
    setTimeout(function() {
      noticesWrapper.style.opacity = '0';

      // Remove the notice content after 2 more seconds (7 seconds total)
      setTimeout(function() {
        noticesWrapper.innerHTML = '';
      }, 2000);
    }, 3000);
  }
}

document.addEventListener("DOMContentLoaded", function() {
  updateNoticeMargin();
  handleNotices();
  window.addEventListener("resize", updateNoticeMargin);
});


document.addEventListener("DOMContentLoaded", function() {
  const body = document.body;
  const html = document.documentElement;

  if (body.classList.contains('logged-in') && body.classList.contains('admin-bar')) {
    html.classList.add('logged-in-admin-bar');
  }
});

// Dodaj ten kod do pliku JavaScript lub umieść w tagach <script> na stronie

jQuery(document).ready(function($) {
  // Obiekt do przechowywania wybranych produktów
  let selectedProducts = {};

  // Obsługa przycisku dodawania SKU
  $('#add-sku-button').on('click', function(e) {
    e.preventDefault();
    const skuInput = $('#sku-input');
    const sku = skuInput.val().trim();

    if (!sku) {
      alert('Podaj SKU produktu.');
      return;
    }

    // Sprawdzenie czy SKU już istnieje
    if (selectedProducts[sku]) {
      alert('Ten produkt jest już dodany.');
      return;
    }

    // Zapytanie AJAX do WooCommerce, aby uzyskać informacje o produkcie
    $.ajax({
      url: woocommerce_params.ajax_url, // Poprawny URL do WordPress AJAX
      type: 'POST',
      data: {
        action: 'get_product_info',
        sku: sku,
        security: wc_form_nonce // Poprawny nonce
      },
      success: function(response) {
        if (response.success) {
          const product = response.data;
          addProductToList(sku, product.name);
          skuInput.val('');
        } else {
          alert('Nie znaleziono produktu o podanym SKU.');
        }
      },
      error: function() {
        alert('Wystąpił błąd podczas wyszukiwania produktu.');
      }
    });
  });

  // Umożliwienie dodawania produktu po naciśnięciu klawisza Enter
  $('#sku-input').on('keypress', function(e) {
    if (e.which === 13) {
      e.preventDefault();
      $('#add-sku-button').click();
    }
  });

  // Funkcja dodająca produkt do listy
  function addProductToList(sku, productName) {
    selectedProducts[sku] = {
      name: productName,
      quantity: 1
    };

    // Tworzenie nowego elementu produktu
    const productHTML = `
            <div class="product-item" data-sku="${sku}">
                <div class="product-info">
                    <span class="product-name">${productName}</span>
                    <span class="product-sku">(${sku})</span>
                </div>
                <div class="product-controls">
                    <label>Ilość: 
                        <input type="number" class="quantity-input" value="1" min="1" max="999">
                    </label>
                    <button type="button" class="remove-product">Usuń</button>
                </div>
            </div>
        `;

    $('#selected-products-container').append(productHTML);
    updateProductsList();

    // Obsługa zmiany ilości
    $('.quantity-input').off('change').on('change', function() {
      const productItem = $(this).closest('.product-item');
      const sku = productItem.data('sku');
      const quantity = parseInt($(this).val());

      if (quantity < 1) $(this).val(1);
      if (quantity > 999) $(this).val(999);

      selectedProducts[sku].quantity = parseInt($(this).val());
      updateProductsList();
    });

    // Obsługa usuwania produktu
    $('.remove-product').off('click').on('click', function() {
      const productItem = $(this).closest('.product-item');
      const sku = productItem.data('sku');

      delete selectedProducts[sku];
      productItem.remove();
      updateProductsList();
    });
  }

  // Aktualizacja ukrytego pola z listą produktów
  function updateProductsList() {
    let productsList = [];

    Object.keys(selectedProducts).forEach(sku => {
      productsList.push(`${sku} - ${selectedProducts[sku].name} (Ilość: ${selectedProducts[sku].quantity})`);
    });

    $('#produkty-lista').val(productsList.join('\n'));
  }

  // Obsługa przeciągnij i upuść dla plików
  const fileUpload = $('.file-upload');

  fileUpload.on('dragover', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).css('border-color', '#CB0015');
  });

  fileUpload.on('dragleave', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).css('border-color', '#CECECE');
  });

  // Obsługa zdarzenia zmiany pliku
  $('input[name="zalacznik"]').on('change', function() {
    const fileName = $(this).val().split('\\').pop();
    if (fileName) {
      $(this).siblings('p').text('Wybrany plik: ' + fileName);
    } else {
      $(this).siblings('p').text('Przeciągnij i upuść plik lub');
    }
  });

  // Walidacja formularza przed wysłaniem
  document.addEventListener('wpcf7submit', function(event) {
    const formData = event.detail.inputs;
    const produktyLista = formData.find(input => input.name === 'produkty_lista');

    if (!produktyLista || !produktyLista.value) {
      alert('Proszę dodać co najmniej jeden produkt.');
      event.preventDefault();
    }
  }, false);
});